// extracted by mini-css-extract-plugin
export default {"wrapper":"prompt__wrapper__fyxzD"};